import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './check-box-group.scss';
import CheckBox from '../check-box/check-box';

const CheckBoxGroup = ({ label, values, callbackOnChange, className }) => (
  Array.isArray(values) &&
  <div className={`${className}`}>
     <span className={css.label}>{label}</span>
    {
      values.map(item => (
        <div key={item.id + label}>
          <CheckBox
            id={item.id}
            name={item.name}
            checked={item.checked}
            disabled={item.disabled}
            callbackOnChange={callbackOnChange}
          />
        </div>
      ))
    }
  </div>
);

CheckBoxGroup.propTypes = {
  label: PropTypes.string,
  values: PropTypes.object,
  callbackOnChange: PropTypes.func,
  className: PropTypes.string
};

export default CheckBoxGroup;
